import ResourcesPage from "../features/resources/ResourcesPage";

export default function ResourcesRoute() {
  return <ResourcesPage />;
}
